import React from "react"
import styles from "./RecaptchaInfo.module.sass"

const RecaptchaInfo = () => {
    const text = {__html: I18n.t('pages.user_session.user.recaptcha_info_html') }

    return <div className={styles.text} dangerouslySetInnerHTML={text}></div>
}

export default RecaptchaInfo
